import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import AppErrorBoundary from "./components/AppErrorBoundary";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import WhatsAppLeadChat from "./components/WhatsAppLeadChat";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3200,
            style: {
              background: "var(--bg-card)",
              color: "var(--text-strong)",
              border: "1px solid var(--border-soft)",
              boxShadow: "0 12px 26px rgba(27, 46, 34, 0.12)",
              borderRadius: "12px",
              fontFamily: "Montserrat, sans-serif",
              fontSize: "13px",
              padding: "12px 14px",
            },
            success: {
              iconTheme: {
                primary: "var(--brand-main)",
                secondary: "#ffffff",
              },
              style: {
                border: "1px solid #cfe4d4",
                background: "#f4fbf6",
              },
            },
            error: {
              iconTheme: {
                primary: "#b94646",
                secondary: "#ffffff",
              },
              style: {
                border: "1px solid #f0d1d1",
                background: "#fff7f7",
              },
            },
          }}
        />
        <Router>
          <AnalyticsTracker />
          <AppErrorBoundary>
            <Navigation />
            <AppRoutes />

            <Footer />
            <WhatsAppLeadChat />
          </AppErrorBoundary>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
